// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"EditorComponentWrapper__wrapper___LFklD","wrapper--selectable":"EditorComponentWrapper__wrapper--selectable___C348f","wrapper--hovered":"EditorComponentWrapper__wrapper--hovered___3belv","wrapper--selected":"EditorComponentWrapper__wrapper--selected___2SrmC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/EditorComponentWrapper/EditorComponentWrapper.scss
// module id = 995
// module chunks = 0